module.exports = __webpack_public_path__ + "static/media/warning.cfc5d9d4.svg";